import gql from 'graphql-tag';

const query = gql`
  query getProjectDetails($id: Int, $slug: String) {
    getProjectDetails(id: $id, slug: $slug) {
      name
      id
      slug
      state
      demo
      presentationTemplates {
        id
        name
      }
      automation {
        crontask
        email
      }
      eindex {
        value
      }
      eindexUnitFahrenheit
      lastProcessedAt
      mentionCount
      mentionCountDetails {
        totalMentionCountWithNull
        totalSentenceCountWithNull
        totalMentionCountWithoutNull
        currentMentionCountWithoutNull
      }
      period {
        startDate
        endDate
      }
      processingHistory {
        mentionCount
        mode
        processingDate
        usedCredits
      }
      projectFilters
      projectInformations
      sources {
        id
        profile
        profileName
        profileState
        source
        projectSourceItem {
          id
          imageLink
          link
          name
        }
      }
      updatedAt
      createdAt
      industryId
      useCaseId
    }
  }
`;

export default query;
